import { ERROR_PATH } from "@/modules/common/pages/error";
import ErrorPage from "@/modules/common/pages/error/error";
import { ReactNode } from "react";

export function BackendErrorRedirect({ children }: { children: ReactNode }) {
  if (window.location.pathname === ERROR_PATH) {
    return <ErrorPage />;
  }

  return children;
}
